import RightContainerNew from "../../checkout/components/RightContainer/RightContainerNew.vue";
import api from "../../checkout/services/api";
import {mapGetters} from "vuex";

export default {
    props: ['additional'],

    components: {
        RightContainerNew,
    },

    data() {
        return {
            tariff: {},
            price: '',
            addon: false
        }
    },

    computed: {
        ...mapGetters(["checkout"]),
    },

    methods: {
        prepareMarketingData() {
            api.post('/public-api/get-presentation-of-tariff', {
                'tariff': this.checkout.tariff,
                'binding': this.checkout.binding,
                'type': 'Mobile Tariff'
            }).then(response => {
                this.tariff = response.data.body
                this.price = response.data.price

                this.$root.$emit('enableContinueButton');
            })
        }
    },

    mounted() {
        this.prepareMarketingData()
    }
}
